
import { defineComponent } from 'vue';
import RefCard from './RefCard.vue';
import SourcesFR from '../assets/sourcesFR.json';
import SourcesUSA from '../assets/sourcesUSA.json';

export default defineComponent({
  name: 'sources',
  components: {
    RefCard,
  },
  data() {
    return {
      SourcesFR,
      SourcesUSA,
    };
  },
  methods: {
    toggleContent(nav: string) {
      const currentSection = document.getElementById(nav) as HTMLElement;
      currentSection.classList.toggle('shown');
    },
  },
});
